import { StatusTag } from "@graffer-inc/console-design-kit";
import { ApplicationRemovalTaskStatus } from "../../../application/domain/application/application-removal-task/application-removal-task-status";

type ApplicationRemovalTaskStatusTagProps = {
  status: ApplicationRemovalTaskStatus;
};

export const ApplicationRemovalTaskStatusTag: React.FC<
  ApplicationRemovalTaskStatusTagProps
> = ({ status }) => {
  switch (status) {
    case "Scheduled":
      return <StatusTag type={"LIGHT"}>削除予定</StatusTag>;
    case "Canceled":
      return <StatusTag type={"SECONDARY"}>キャンセル</StatusTag>;
    case "WIP":
      return <StatusTag type={"LIGHT"}>削除中</StatusTag>;
    case "Done":
      return (
        <StatusTag type={"SUCCESS"} hiddenCheckIcon>
          削除完了
        </StatusTag>
      );
    case "Error":
      return <StatusTag type={"ERROR"}>エラー</StatusTag>;
    default:
      throw new Error("Invalid application removal task status");
  }
};
